var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-preview",style:(_vm.isValidHexColor ? { backgroundColor: _vm.value } : null)},[(!_vm.isValidHexColor)?_c('span',[_vm._v("×")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }